import {
  query,
  where,
  orderBy,
  limit,
  getDocs,
  startAfter,
} from "firebase/firestore";

import {
  getActivitiesCollectionRef,
  getHistoriesCollectionRef,
  getSessionRef,
  getVisitorRef,
} from "../../../firebase/collectionReferences";

export async function getHistories(selectedProperties, dateRange, type) {
  const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
  const historiesRef = getHistoriesCollectionRef();
  const chunkSize = 30; // Firestore limit for IN queries

  const chunks = [];
  for (let i = 0; i < selectedProperties.length; i += chunkSize) {
    chunks.push(selectedProperties.slice(i, i + chunkSize));
  }

  const allDocs = [];
  for (const chunk of chunks) {
    const historyQuery = query(
      historiesRef,
      where("propertyId", "in", chunk),
      where("createdAt", ">=", formattedDates[0]),
      where("createdAt", "<=", formattedDates[1]),
      orderBy("createdAt", "desc")
    );

    const querySnapshot = await getDocs(historyQuery);
    querySnapshot.forEach((doc) => {
      allDocs.push({
        ...doc.data(),
        id: doc.id,
      });
    });
  }

  let filteredDocs = allDocs;

  if (type === "engaged") {
    filteredDocs = allDocs?.filter(
      (item) =>
        !item.hasOwnProperty("missed") && !item.hasOwnProperty("engaged")
    );
  } else if (type === "missed") {
    filteredDocs = allDocs?.filter((item) => item.missed);
  } else if (type === "notengaged") {
    filteredDocs = allDocs?.filter((item) => item.engaged === false);
  } else if (type === "conversed") {
    filteredDocs = allDocs?.filter((item) => item.conversed);
  } else {
    filteredDocs = allDocs;
  }

  return filteredDocs;
}

export async function getTotalHistoriesCount(selectedProperties, dateRange) {
  try {
    const formattedDates = [new Date(dateRange[0]), new Date(dateRange[1])];
    const historiesRef = getHistoriesCollectionRef();

    const querySnapshot = await getDocs(
      query(
        historiesRef,
        where("propertyId", "in", selectedProperties),
        where("createdAt", ">=", formattedDates[0]),
        where("createdAt", "<=", formattedDates[1]),
        orderBy("createdAt", "desc")
      )
    );
    const totalHistories = querySnapshot.size; // Total number of histories retrieved

    return totalHistories;
  } catch (error) {
    console.error("Error fetching total histories count:", error);
    throw error;
  }
}

export function getMessagesQuery(identifier, session) {
  const visitorRef = getVisitorRef(identifier);
  const sessionRef = getSessionRef(visitorRef, session);
  const activitiesRef = getActivitiesCollectionRef(sessionRef);

  return query(activitiesRef, orderBy("created_at", "desc"));
}

export async function getHistoryByMsg(histories, message) {
  const activitiesIds = []; // Initialize an empty array to collect activity ids.

  await Promise.all(
    (histories || []).map(async (history) => {
      let messagesQuery = await getMessagesQuery(
        history?.identifier,
        history?.session
      );
      const messages = (await getDocs(messagesQuery)).docs.map((x) => ({
        ...x.data(),
        id: x.id,
      }));
      let filteredActivities = messages?.filter((msg) => msg.type === 0);
      filteredActivities
        ?.filter((activity) =>
          activity.body.toLowerCase().includes(message.toLowerCase())
        )
        ?.forEach((item) =>
          activitiesIds.push({
            activityId: item.id,
            sessionId: history?.session,
          })
        );
    })
  );

  let sessionIds = activitiesIds?.map((item) => item.sessionId);
  const results = histories?.filter((item) =>
    sessionIds.includes(item.session)
  );

  return results;
}
